export default () => {
    const dataLayer = getShoptetDataLayer();
    const isProductDetailPage = dataLayer.pageType === "productDetail";

    if (isProductDetailPage) {
        console.log("product detail page");
        const detailWrapper = $(".p-info-wrapper");
        const productAlternatives = $("#productsAlternative");

        detailWrapper.prepend($(".p-short-description"));
        detailWrapper.prepend($(".p-detail-inner-header"));

        productAlternatives.removeClass("tab-pane").removeClass("fade");
        productAlternatives.removeAttr("tabpanel");
        $(".advanced-parameter-inner").removeClass("show-tooltip");

        $(".availability-value span.parameter-dependent").each(function() {
            const availability = $(this)
                .find("span.availability-label")
                .text()
                .trim();

            if (availability.includes("Vyprodáno")) {
                $(this).addClass("sold-item");
            }
        });

        if ($(".sold-item").length) {
            const indexItem = $(".sold-item").index();
            console.log(indexItem);

            $(".advanced-parameter")
                .eq(indexItem)
                .addClass("no-availability-product-detail");
        }

        // kontroluje, zda má produkt varianty, pokud ne, produkt není skladem
        const advancedParametr = $(".advanced-parameter");
        if (!advancedParametr.length) {
            $(".availability-value").addClass("show");
            //$(".add-to-cart-button").prop("disabled", true);
        } else {
            advancedParametr.each(function() {
                const parametrValue = $(this).find(".parameter-value");
                const parametrInner = $(this).find(".advanced-parameter-inner");

                parametrValue.appendTo(parametrInner);
            });
        }

        const detailTabs = document.querySelector(".p-detail-tabs-wrapper");
        if (detailTabs) {
            $(".p-detail-tabs-wrapper .row .responsive-nav")
                .removeClass("col-sm-12")
                .addClass("col-sm-2");
            $(".p-detail-tabs-wrapper .row .col-sm-12")
                .removeClass("col-sm-12")
                .addClass("col-sm-9");

            $(".p-detail-tabs-wrapper").insertBefore(".benefitBanner");
        }

        //$(".product-top .col-xs-12:eq(0)").remove();
    }
};